import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import TreeView from '../../../../../../../components/TreeViewer/index';
import Toggle from 'react-toggle';

const FilterAccordionTreeView = ({
  filterOptions,
  setFilterOptions,
  title, handleApplyFilters,
  filtersApplied,
  showClassicCourseSlider,
  context
}) => {
  const [expand, setExpand] = useState(false);
  const [classicCourseTree, setClassicCourseTree] = useState([]);
  const [newCourseTree, setNewCourseTree] = useState([]);

  const handleClearFilters = (e) => {
    e.stopPropagation();
    setFilterOptions(f => f.map(t => ({ ...t, isChecked: false, checkIndeterminate: false })));
    if (filtersApplied) handleApplyFilters(title);
  };

  const handleShowClassicCourseChange = () => {
    var newShowClassicCourseState = !context.showClassicCourses;

    var tempFilterOptions = filterOptions.map(f => ({ ...f, isHidden: f.name.includes(' (0)') || (f.parentId ? false : !f.isHidden) }));
    var previousFilterStates = [];
    if (newShowClassicCourseState) {
      setNewCourseTree(filterOptions);
      previousFilterStates = classicCourseTree;
    } else {
      setClassicCourseTree(filterOptions);
      previousFilterStates = newCourseTree;
    }

    tempFilterOptions = tempFilterOptions.map(f => {
      var prevState = previousFilterStates.find(pf => pf.id == f.id);

      return (
        {
          ...f,
          isChecked: prevState?.isChecked,
          isExpanded: prevState?.isExpanded,
          checkIndeterminate: prevState?.checkIndeterminate
        }
      );
    });

    context.setShowClassicCourses(newShowClassicCourseState);
    setFilterOptions(tempFilterOptions);
  };

  return (
    <>
      <div className={'d-flex flex-column mb-3'}>
        <div className='filterAccordionTitle' onClick={() => setExpand(!expand)}>
          <h2 style={{ fontSize: 'max(0.8vw, 12px)' }}>{title}</h2>
          <div className='d-flex flex-row gap-2'>
            {filterOptions && filterOptions.filter(f => f.isChecked).length >= 1 && <div className='clearFilterBtn' onClick={(e) => handleClearFilters(e)}>
              <FontAwesomeIcon style={{ fontSize: '16px' }} icon={faCircleXmark} />
              <span>Clear</span>
            </div>}
            <div className={`expandFilterButton ${expand ? 'expanded' : ''}`}><FontAwesomeIcon color='#7085C5' style={{ fontSize: '16px' }} icon={faChevronRight} /></div>
          </div>
        </div>
        <div className={`filterOptions ${expand ? 'expanded' : ''}`}>
          {showClassicCourseSlider && filterOptions && filterOptions.length > 0 && context.showClassicCoursesToggle &&
          <div className='d-flex flex-row' style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleShowClassicCourseChange()}>
            <Toggle
              id="showClassicTopicsToggle"
              checked={context.showClassicCourses}
              icons={false}
              className='custom-toggle'
            />
            <div>Show classic courses</div>
          </div>}
          {((filterOptions && filterOptions.length <= 0) || filterOptions.filter(f => !f.isHidden).length <= 0) && <div>No filters available</div>}

          <TreeView data={filterOptions} setData={setFilterOptions} style='checkbox' />
        </div>
        <div style={{ border: '1px solid #D4DEFF', marginTop: '.75em' }}></div>
      </div>
    </>
  );
};

FilterAccordionTreeView.propTypes = {
  filterOptions: PropTypes.array,
  setFilterOptions: PropTypes.any,
  selectedFilters: PropTypes.array,
  title: PropTypes.string,
  handleApplyFilters: PropTypes.func,
  filtersApplied: PropTypes.bool,
  showClassicCourseSlider: PropTypes.bool,
  context: PropTypes.object,
};

export default FilterAccordionTreeView;